// extracted by mini-css-extract-plugin
export default {"toggle-visibility":"TogleVisibilityButton_toggle-visibility__eiqYn","toggle-visibility--active":"TogleVisibilityButton_toggle-visibility--active__eRVHl"};